module.exports = __webpack_public_path__ + "img/1509970230.3eb394d5.jpg";